import styled, { css } from 'styled-components';
import { CSSObject } from 'styled-components/dist/types';

interface OverlayProps {
  $distanciaTopo: number;
  $valorSobreposicaoDosDemaisComponentes: number;
  $cssAdicional?: CSSObject | string;
}

export const Overlay = styled.div<OverlayProps>`
  position: fixed;
  top: ${({ $distanciaTopo }) => $distanciaTopo}px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.tokens.colors.overlay};
  transition: background-color 0.3s ease;
  z-index: ${({ $valorSobreposicaoDosDemaisComponentes }) =>
    $valorSobreposicaoDosDemaisComponentes};
  ${({ $cssAdicional }) =>
    $cssAdicional &&
    css`
      ${$cssAdicional}
    `}
`;
